/**
 * Deter casual image downloads (right-click, drag, long-press).
 * Does not block screenshots or dev tools.
 */
(function () {
  'use strict';

  var EXCLUDE_SELECTOR = [
    '[data-no-image-protect]',
    '.site-header',
    '.site-footer',
    '.footer',
    '.announcement-bar',
    '.mobile-nav',
    '.header__logo',
    '.payment-icons',
    '.trust-icon',
    '.product-zero__trust-icon',
    '.icon',
    'svg'
  ].join(',');

  var WRAP_SELECTOR = [
    '.collection-card__media',
    '.product-card__image-wrap',
    '.product-zero__gallery-main',
    '.product-zero__gallery-slide',
    '.product-zero__overview-media',
    '.homepage-explore__media',
    '.hero__image-wrapper',
    '.hero__media',
    '.lifestyle-showcase__media',
    '.featured-collection-zero__media',
    '.video-feature__media',
    '.recent-collabs__media',
    '.home-promo-banner__media',
    '.home-category-icons__icon',
    '.collection-hero__image-wrapper'
  ].join(',');

  function isExcluded(el) {
    return !!(el && el.closest && el.closest(EXCLUDE_SELECTOR));
  }

  function isSmallIcon(img) {
    var w = img.naturalWidth || img.width || img.clientWidth || 0;
    var h = img.naturalHeight || img.height || img.clientHeight || 0;
    return w > 0 && h > 0 && w < 48 && h < 48;
  }

  function isProtectedImage(el) {
    if (!el || el.tagName !== 'IMG') return false;
    if (isExcluded(el)) return false;
    if (isSmallIcon(el)) return false;
    if (!el.closest('#MainContent, .product-page--zero, .collection-zero, main.main-content')) return false;
    return true;
  }

  function findShield(el) {
    if (!el || !el.closest) return null;
    return el.closest(WRAP_SELECTOR) || el.parentElement;
  }

  function protectImage(img) {
    if (!isProtectedImage(img)) return;
    img.classList.add('image-protect__target');
    img.setAttribute('draggable', 'false');
    img.setAttribute('oncontextmenu', 'return false;');

    var shield = findShield(img);
    if (shield && !shield.classList.contains('image-protect__shield')) {
      shield.classList.add('image-protect__shield');
    }
  }

  function scan(root) {
    (root || document).querySelectorAll('img').forEach(protectImage);
  }

  function onContextMenu(e) {
    if (isProtectedImage(e.target)) {
      e.preventDefault();
    }
  }

  function onDragStart(e) {
    if (isProtectedImage(e.target)) {
      e.preventDefault();
    }
  }

  function initImageProtection() {
    scan(document);
    document.addEventListener('contextmenu', onContextMenu);
    document.addEventListener('dragstart', onDragStart);
  }

  document.addEventListener('DOMContentLoaded', initImageProtection);
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
